module.exports = __webpack_public_path__ + "static/media/consumo_nota_blog.b6b9dfdf.png";